var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{attrs:{"color":_vm.headerColor}},[_vm._t("header")],2),_c('v-expansion-panel-content',{attrs:{"color":_vm.contentColor}},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }